/* eslint-disable react/jsx-no-bind */
import React from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import { Alert, Slide } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAdminError,
  clearAuthError,
  clearTeacherError,
} from "../../redux/actions";
import Locale from "../../locales";

const DURATION_TIMEOUT = 3000;
const ErrorSnackbar = () => {
  const dispatch = useDispatch();
  const authError = useSelector((state) => state.authReducer.error);
  const teacherError = useSelector((state) => state.teacherReducer.error);
  const adminError = useSelector((state) => state.adminReducer.error);

  function SlideTransition(props) {
    return <Slide {...props} direction="down" />;
  }

  const error = authError || teacherError || adminError;

  if (authError) {
    setTimeout(() => {
      dispatch(clearAuthError());
    }, DURATION_TIMEOUT);
  } else if (adminError) {
    setTimeout(() => {
      dispatch(clearAdminError());
    }, DURATION_TIMEOUT);
  } else if (teacherError) {
    setTimeout(() => {
      dispatch(clearTeacherError());
    }, DURATION_TIMEOUT);
  }

  return (
    <>
      <Stack>
        <Snackbar
          sx={{ marginTop: "60px" }}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={Boolean(error)}
          autoHideDuration={1000}
          TransitionComponent={SlideTransition}
          onClose={() => {}}>
          <Alert severity="error" sx={{ width: "100%" }}>
            {error || Locale.t("something_went_wrong")}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
};

export default ErrorSnackbar;
